import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, Inbox, FileText, Store, Settings, LogOut, BookLock, KeyRound, Contact, PenSquare, Route as RouteIcon, ClipboardList, Eye, Images, Megaphone, MessagesSquare, HeartHandshake, History, LayoutGrid, BookOpenCheck, Sparkles, SlidersHorizontal } from "lucide-react";
import { adminLogout } from "../lib/adminAuth";
import { CalendarDays } from "lucide-react";
import { MailCheck } from "lucide-react";

const TABS = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard },
  { to: "/admin/crm", label: "CRM", icon: Contact },
  { to: "/admin/campaigns", label: "Campaigns", icon: Megaphone },
  { to: "/admin/access-emails", label: "Access Emails", icon: MailCheck },
  { to: "/admin/planner", label: "Planner", icon: LayoutGrid },
  { to: "/admin/messaging", label: "Messaging", icon: MessagesSquare },
  { to: "/admin/send-log", label: "Send Log", icon: History },
  { to: "/admin/immersion-reviews", label: "Immersion", icon: HeartHandshake },
  { to: "/admin/journey", label: "Journey", icon: RouteIcon },
  { to: "/admin/book-review", label: "Book Review", icon: BookOpenCheck },
  { to: "/admin/plain-words", label: "Plain Words", icon: Sparkles },
  { to: "/admin/book-extras", label: "Book Extras", icon: SlidersHorizontal },
  { to: "/admin/readers", label: "Readers", icon: Users },
  { to: "/admin/codes", label: "Access Codes", icon: KeyRound },
  { to: "/admin/preview", label: "Preview Site", icon: Eye },
  { to: "/admin/reflections", label: "Reflections", icon: Inbox },
  { to: "/admin/applications", label: "Applications", icon: FileText },
  { to: "/admin/orientation", label: "Orientation", icon: ClipboardList },
  { to: "/admin/vault", label: "Vault", icon: BookLock },
  { to: "/admin/telegram", label: "Telegram", icon: CalendarDays },
  { to: "/admin/media", label: "Media", icon: Images },
  { to: "/admin/offerings", label: "Offerings & Gallery", icon: Store },
  { to: "/admin/editor", label: "Website Editor", icon: PenSquare },
  { to: "/admin/config", label: "Config", icon: Settings },
];

export const AdminNav = ({ onLogout }) => {
  const { pathname } = useLocation();
  return (
    <div className="mb-8 flex flex-wrap items-center gap-1.5 border-b border-ivory-400/60 pb-4" data-testid="admin-nav">
      {TABS.map((t) => {
        const active = pathname === t.to;
        const Icon = t.icon;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={`adminnav-${t.label.toLowerCase().split(" ")[0]}`}
            className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 font-display text-sm transition ${
              active ? "bg-ink text-ivory-50" : "text-ink-soft hover:bg-gold/10 hover:text-ink"
            }`}
          >
            <Icon className="h-4 w-4" /> {t.label}
          </Link>
        );
      })}
      <button
        type="button"
        onClick={onLogout || adminLogout}
        data-testid="adminnav-logout"
        className="ml-auto inline-flex items-center gap-1.5 rounded-full border border-ivory-400/70 px-3.5 py-2 font-display text-sm text-ink-soft hover:text-ink"
      >
        <LogOut className="h-4 w-4" /> Sign out
      </button>
    </div>
  );
};
